import { render, staticRenderFns } from "./PractitionerApplicationDetails.vue?vue&type=template&id=27eb3248&scoped=true&"
import script from "./PractitionerApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./PractitionerApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerApplicationDetails.vue?vue&type=style&index=0&id=27eb3248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb3248",
  null
  
)

export default component.exports